import * as React from "react";
import {Field} from "../../form/Field";
import {Input} from "../../form/fields/Input";
import {FormStore} from "../../../stores/FormStore";
import {Col, FormGroup, Row} from 'reactstrap';
import {observable} from "mobx";
import Form from "../../form/Form";
import {Checkbox} from "../../form/fields/Checkbox";
import {BooleanRadios} from "../../form/fields/BooleanRadios";
import {Textarea} from "../../form/fields/Textarea";
import {Select} from "../../form/fields/Select";
import {api} from '../../../api';
import {DatePicker} from "../../form/fields/DatePicker";

class FormData {
    @observable firstName = 'Paul';
    @observable lastName = 'Phoenix';
    @observable email = 'paul@phoenix.com';
    @observable password = '';
    @observable textarea1 = 'This is some text.';
    @observable textarea2 = '';
    @observable checkboxValue1 = true;
    @observable checkboxValue2 = false;
    @observable checkboxValue3 = true;
    @observable radioValue = true;
    @observable select1Value = 'two';
    @observable select2Value = null;
    @observable select3Value = [{id: 1}, {id: 3}];
    @observable date1Value = null;
    @observable date2Value = '2018-12-04';
}

export class FormPage extends React.Component {
    formStore: FormStore<FormData>;

    constructor(props: any) {
        super(props);

        this.formStore = new FormStore(new FormData());
        this.formStore.setErrors({
            errors: {
                lastName: "Invalid last name",
            }
        });
        this.formStore.onSubmitCallback = (data: FormData) => {
            alert('Submitted');
            return Promise.resolve();
        };
    }

    render() {
        return (
            <div>
                <h1 className="main-heading pb-3">Form Docs</h1>
                <div className="box-shadow p-3 p-md-4">
                    <Form store={this.formStore}>
                        <Row className="form-row">
                            <Col md={6}>
                                <Field
                                    label="Text Input"
                                    name="firstName"
                                    component={Input}
                                    required={true}
                                    store={this.formStore}
                                />
                            </Col>
                            <Col md={6}>
                                <Field
                                    label="Text Input Error"
                                    name="lastName"
                                    component={Input}
                                    store={this.formStore}
                                />
                            </Col>
                        </Row>
                        <Row className="form-row">
                            <Col md={6}>
                                <Field
                                    label="Email"
                                    name="email"
                                    type="email"
                                    component={Input}
                                    store={this.formStore}
                                />
                            </Col>
                            <Col md={6}>
                                <Field
                                    label="Password"
                                    name="password"
                                    type="password"
                                    component={Input}
                                    store={this.formStore}
                                />
                            </Col>
                        </Row>
                        <Row className="form-row">
                            <Col md={6}>
                                <Field
                                    label="Textarea"
                                    name="textarea1"
                                    component={Textarea}
                                    store={this.formStore}
                                />
                            </Col>
                            <Col md={6}>
                                <Field
                                    label="Textarea Placeholder"
                                    name="textarea2"
                                    rows={5}
                                    placeholder="This is some placeholder text"
                                    component={Textarea}
                                    store={this.formStore}
                                />
                            </Col>
                        </Row>
                        <Row className="form-row">
                            <Col md={6}>
                                <Field
                                    name="checkboxValue1"
                                    component={Checkbox}
                                    inputLabel="Checkbox"
                                    store={this.formStore}
                                />
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Field
                                        name="checkboxValue2"
                                        component={Checkbox}
                                        inputLabel="Inline checkbox"
                                        inline
                                        store={this.formStore}
                                    />
                                    <Field
                                        name="checkboxValue3"
                                        component={Checkbox}
                                        inputLabel="Some other checkbox"
                                        inline
                                        store={this.formStore}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row className="form-row">
                            <Col md={6}>
                                <FormGroup>
                                    <Field
                                        name="radioValue"
                                        component={BooleanRadios}
                                        trueLabel="Active"
                                        falseLabel="In-Active"
                                        inline
                                        store={this.formStore}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row className="form-row">
                            <Col md={6}>
                                <FormGroup>
                                    <Field
                                        name="select1Value"
                                        label="Select"
                                        component={Select}
                                        options={[{value: 'one', label: 'One'}, {value: 'two', label: 'Two'}, {value: 'three', label: 'Three'}]}
                                        store={this.formStore}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={3}>
                                <FormGroup>
                                    <Field
                                        name="select2Value"
                                        label="Load from API"
                                        component={Select}
                                        loadOptions={api.state.getListAction}
                                        store={this.formStore}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={3}>
                                <FormGroup>
                                    <Field
                                        name="select3Value"
                                        label="Multiple select"
                                        component={Select}
                                        multi
                                        loadOptions={api.state.getListAction}
                                        valueObject={true}
                                        store={this.formStore}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row className="form-row">
                            <Col md={3}>
                                <FormGroup>
                                    <Field
                                        name="date1Value"
                                        label="Date picker"
                                        component={DatePicker}
                                        store={this.formStore}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={3}>
                                <FormGroup>
                                    <Field
                                        name="date2Value"
                                        label="Custom format"
                                        component={DatePicker}
                                        dateFormat="D MMM YYYY"
                                        store={this.formStore}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/pages/docs/FormPage.tsx